<template>
  <div class="form-container">
    <el-tabs
      v-model="activeTab"
      class="login-tabs"
      :before-leave="beforeTabLeave"
    >
      <el-tab-pane label="培训基本设置" name="trainSetting">
        <el-form
          ref="trainingForm"
          :rules="trainingFormRules"
          :model="trainingForm"
          label-width="200px"
        >
          <el-form-item label="培训名称" prop="name">
            <el-input
              placeholder="请输入培训名称"
              v-model="trainingForm.name"
              maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="培训简介" prop="summary">
            <WangEditorVue
              :content="trainingForm.summary"
              @getEditorContent="getEditorContent"
            ></WangEditorVue>
          </el-form-item>
          <el-form-item label="培训时间" prop="trainingTime">
            <el-date-picker
              v-model="trainingForm.trainingTime"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="地区设置" prop="area">
            <div class="select-area">
              <el-scrollbar>
                <el-tree
                  :data="areaList"
                  show-checkbox
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :props="defaultProps"
                  @check-change="handleCheckChangeArea"
                  @check="currentChangeArea"
                >
                </el-tree>
              </el-scrollbar>
            </div>
          </el-form-item>
          <el-form-item label="参与培训的岗位">
            <template>
              <!-- <el-radio-group v-model="trainingForm.trainingPosition">
            <el-radio label="all">全部</el-radio>
            <el-radio label="custom">自定义</el-radio>
          </el-radio-group> -->
              <el-table
                v-if="
                  selectedPositionList.length != 0 &&
                  trainingForm.trainingPosition == 'custom'
                "
                :data="selectedPositionList"
                max-height="200"
                :show-header="false"
              >
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="postionName"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <!-- <i class="el-icon-edit-outline icon-style"></i> -->
                    <i
                      class="el-icon-delete icon-style"
                      @click="deleteSelectedPosition(scope)"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="trainingForm.trainingPosition == 'custom'">
                <!-- <div style="color: #d6d6d6" v-if="selectedPositionList.length == 0">
              未设置则默认全部岗位
            </div> -->
                <div class="position-setting" @click="dialogPositionSetting">
                  <i class="el-icon-plus"></i>
                  <span>添加岗位</span>
                </div>

                <el-alert
                  v-if="this.trainingForm.area.length == 0"
                  title="请先选择培训地区"
                  type="warning"
                  show-icon
                  :closable="false"
                  style="width: 500px; height: 30px; margin-top: 10px"
                >
                </el-alert>
              </div>
              <dialogPositionVue
                :showDialogPositionSetting="showDialogPositionSetting"
                @colseDialog="colseDialog"
                @selectedPosition="selectedPosition"
              ></dialogPositionVue>
            </template>
          </el-form-item>
          <!-- <el-form-item label="参与培训的单位">
            <template>
              <el-table
                v-if="
                  selectedUnitList.length != 0 &&
                  trainingForm.trainingUnit == 'custom'
                "
                :data="selectedUnitList"
                max-height="200"
                :show-header="false"
              >
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="companyName"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <i
                      class="el-icon-delete icon-style"
                      @click="deleteSelectedUnit(scope)"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="trainingForm.trainingUnit == 'custom'">
                <div class="unit-setting" @click="dialogUnitSetting">
                  <i class="el-icon-plus"></i>
                  <span>添加单位</span>
                </div>
                <el-alert
                  v-if="this.trainingForm.area.length == 0"
                  title="请先选择培训地区"
                  type="warning"
                  show-icon
                  :closable="false"
                  style="width: 500px; height: 30px; margin-top: 10px"
                >
                </el-alert>
              </div>
              <dialogUnitVue
                :showDialogUnitSetting="showDialogUnitSetting"
                :areaIds="trainingForm.area"
                @colseDialog="colseDialog"
                @selectedUnit="selectedUnit"
                :selectedUnitList="selectedUnitList"
              ></dialogUnitVue>
            </template>
          </el-form-item> -->
          <el-form-item label="选择课程" prop="course">
            <el-table
              v-if="selectedCourseTableList.length != 0"
              :data="selectedCourseTableList"
              max-height="200"
              :show-header="false"
            >
              <el-table-column type="index"></el-table-column>
              <!-- <el-table-column prop="position.postionName"></el-table-column> -->
              <!-- <el-table-column prop="company.companyName"></el-table-column> -->
              <el-table-column prop="lesson.name"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <!-- <i class="el-icon-edit-outline icon-style"></i> -->
                  <i
                    class="el-icon-delete icon-style"
                    @click="deleteSelectedCourse(scope)"
                  ></i>
                  <el-button
                    type="text"
                    @click="dialogHoursSetting(scope.row, scope.$index)"
                    >设置必修课时</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- <el-button
          type="text"
          v-if="selectedCourseTableList.length > 2"
          @click="$router.push({ path: '/moreTrainingCourse' })"
          >查看更多培训课程</el-button
        > -->
            <template>
              <div class="select-course" @click="dialogCourseSetting">
                <i class="el-icon-plus"></i>
                <span>课程设置</span>
              </div>
            </template>
            <el-alert
              v-if="
                // this.selectedUnitList.length == 0 ||
                this.selectedPositionList.length == 0
              "
              title="请先选择岗位"
              type="warning"
              show-icon
              :closable="false"
              style="width: 500px; height: 30px; margin-top: 10px"
            >
            </el-alert>
            <dialogCourseVue
              :showDialogCourseSetting="showDialogCourseSetting"
              @colseDialog="colseDialog"
              @selectedUnitAndPositionAndCourse="
                selectedUnitAndPositionAndCourse
              "
              :selectedUnitList="
                selectedUnitList.length == 0
                  ? $store.state.allUnitList
                  : selectedUnitList
              "
              :selectedPositionList="
                selectedPositionList.length == 0
                  ? $store.state.allPositionList
                  : selectedPositionList
              "
              :selectedCourseTableList="selectedCourseTableList"
              :courseIds="trainingForm.courseIds"
            ></dialogCourseVue>
          </el-form-item>
          <el-form-item label="是否公开" prop="status">
            <el-switch v-model="trainingForm.status"> </el-switch>
          </el-form-item>
          <el-form-item label="报名人数限制" prop="trainingCount">
            <el-radio-group v-model="trainingForm.trainingCountState">
              <el-radio :label="false">不限</el-radio>
              <el-radio :label="true">限制人数</el-radio>
              <el-input-number
                v-if="trainingForm.trainingCountState"
                @change="toInteger"
                :min="1"
                :step="1"
                v-model.number="trainingForm.trainingCount"
              ></el-input-number>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否开启申请证书操作" prop="isCertificateApply">
            <el-radio-group v-model="trainingForm.isCertificateApply">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="证书上的课程学时" prop="classHour">
            <el-input
              placeholder="请输入证书上的课程学时"
              v-model="trainingForm.classHour"
              show-word-limit
              style="width: 200px"
            ></el-input
            >个
          </el-form-item>
          <el-form-item label="证书上的课程类型">
            <el-input
              placeholder="请输入证书上的课程类型"
              v-model="trainingForm.classType"
              maxlength="10"
              show-word-limit
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="专业类别">
            <el-input
              placeholder="请输入专业类别:"
              v-model="trainingForm.ProfessionalCategory"
              maxlength="50"
              type="textarea"
              show-word-limit
              style="width: 500px; height: 50px"
            ></el-input>
          </el-form-item>
          <el-form-item label="培训年份设置" prop="trainingPeriod">
            <template>
              <el-input
                v-model.number="trainingForm.trainingPeriod"
                show-word-limit
                style="width: 100px"
              ></el-input>
              年
              <div style="font-size: 14px; color: #999999">
                说明：此处设置决定证书编码上的年份编码显示的内容。
              </div>
            </template>
          </el-form-item>
          <el-form-item label="培训地区编码设置" required>
            <template>
              <el-radio v-model="encoding" label="1" @change="encodingChange"
                >按照培训行政区赋值编码</el-radio
              >
              <el-radio v-model="encoding" label="2" @change="encodingChange"
                >按照用户所在地赋值编码</el-radio
              >
              <div v-if="this.encoding == 1">
                <el-form-item prop="trainingArea">
                  设置培训地区编码:
                  <el-input
                    v-model="trainingForm.trainingArea"
                    show-word-limit
                    style="width: 150px"
                  ></el-input>
                  <div style="font-size: 14px; color: #999999">
                    说明：此处设置的编码将赋值于本培训所颁发的所有证书的地区编码上，此处必须设置6位数。
                  </div>
                </el-form-item>
              </div>
              <div v-if="this.encoding == 2">
                <el-form-item prop="UserregionArea">
                  默认培训地区编码:
                  <el-input
                    v-model="trainingForm.UserregionArea"
                    show-word-limit
                    style="width: 150px"
                  ></el-input>
                </el-form-item>
                <div style="margin-top: 8px">
                  用户所在地编码调取层级:
                  <el-radio-group v-model="CodingHierarchy">
                    <el-radio :label="1">省级</el-radio>
                    <el-radio :label="2">市级</el-radio>
                    <el-radio :label="3">区县级</el-radio>
                  </el-radio-group>
                </div>
                <div style="font-size: 14px; color: #999999">
                  <p>说明：</p>
                  <p style="margin: -25px 0 -25px 0">
                    1、如果用户没有设置所在地的话，则赋予用户默认行政区编码，此处必须设置6位数。
                  </p>
                  <p>
                    2、调取层级表示系统将调取用户所在地编码的哪一层级，例如选择省级，则只调取省级编码，这样给用户颁发的证书的地区编码则为“xx0000”
                  </p>
                </div>
              </div>
            </template>
          </el-form-item>
          <el-form-item class="button-container">
            <el-button
              style="width: 150px"
              type="primary"
              @click="trainingNextStep('trainingForm')"
              >下一页</el-button
            >
            <el-button style="width: 150px" type="test" @click="cancel"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="所用章设置" name="chapterUsed">
        <el-form
          :model="dynamicValidateForm"
          ref="dynamicValidateForm"
          label-width="100px"
          class="demo-dynamic"
        >
          <h3>考试机构章设置</h3>
          <!-- :prop="'domains.' + index + '.examineSealName'"
            :rules="{
              required: true,
              message: '请输入章的名称',
              trigger: 'blur',
            }" -->
          <el-form-item
            v-for="(domain, index) in dynamicValidateForm.domains"
            :label="index > 0 ? '章的名称' + index : '章的名称'"
            :key="domain.key"
          >
            <el-input
              v-model="domain.examineSealName"
              placeholder="请输入章的名称"
            ></el-input>

            <span>{{
              index > 0 ? "章" + index + "(500X500)" : "章(500X500)"
            }}</span>
            <el-upload
              class="avatar-uploader"
              :show-file-list="false"
              action="none"
              :auto-upload="false"
              :on-change="templateFileChange"
            >
              <img
                @click="templateFileClick(index)"
                v-if="domain.examineSealUrl"
                :src="domain.examineSealUrl"
                class="avatar"
              />

              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
                @click="templateFileClick(index)"
              ></i>
            </el-upload>
            <el-button @click.prevent="removeDomain(domain)">删除</el-button>
          </el-form-item>
          <el-form-item>
            <div class="position-setting" @click="addDomain">
              <i class="el-icon-plus"></i>
              <span>章</span>
            </div>
          </el-form-item>
          <h3>培训机构章设置</h3>
          <!-- :prop="'trainingDomains.' + index + '.trainingSealName'"
            :rules="{
              required: true,
              message: '请输入章的名称',
              trigger: 'blur',
            }" -->
          <el-form-item
            v-for="(domain, index) in dynamicValidateForm.trainingDomains"
            :label="index > 0 ? '章的名称' + index : '章的名称'"
            :key="domain.key"
          >
            <el-input
              v-model="domain.trainingSealName"
              placeholder="请输入章的名称"
            ></el-input>

            <span>章(500X500)</span>
            <el-upload
              class="avatar-uploader"
              :show-file-list="false"
              action="none"
              :auto-upload="false"
              :on-change="trainingFileChange"
            >
              <img
                @click="trainingFileClick(index)"
                v-if="domain.trainingSealUrl"
                :src="domain.trainingSealUrl"
                class="avatar"
              />

              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
                @click="trainingFileClick(index)"
              ></i>
            </el-upload>
            <el-button @click.prevent="trainingRemoveDomain(domain)"
              >删除</el-button
            >
          </el-form-item>
          <el-form-item>
            <div class="position-setting" @click="trainingAddDomain">
              <i class="el-icon-plus"></i>
              <span>章</span>
            </div>
          </el-form-item>
          <el-form-item style="text-align: center; margin-top: 100px">
            <el-button style="width: 150px" type="primary" @click="previousPage"
              >上一页</el-button
            >
            <el-button
              style="width: 150px"
              type="primary"
              @click="dynamicNextStep('dynamicValidateForm')"
              >下一步</el-button
            >
            <el-button style="width: 150px" type="test" @click="cancel"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="考试及直播设置" name="examination">
        <el-form
          ref="examinationForm"
          :rules="examinationFormRules"
          :model="examinationForm"
          label-width="200px"
        >
          <el-form-item label="考试GUID">
            <el-input
              placeholder="请输入考试GUID"
              v-model="examinationForm.id"
            ></el-input>
            <span style="color: #999999"
              >说明：考试GUID可到“考试列表”当中进行查看。</span
            >
          </el-form-item>
          <!-- <el-form-item label="考试链接">
            <el-input
              placeholder="请输入考试链接"
              v-model="examinationForm.url"
            ></el-input>
            <span style="color: #999999"
              >说明：输入时请带着“http://”或“https://”。</span
            >
          </el-form-item> -->
          <el-form-item label="直播链接">
            <el-input
              placeholder="请输入直播链接"
              v-model="examinationForm.liveUrl"
            ></el-input>
            <span style="color: #999999"
              >说明：输入时请带着“http://”或“https://”。</span
            >
          </el-form-item>
          <el-form-item style="text-align: center; margin-top: 100px">
            <el-button style="width: 150px" type="primary" @click="previousPage"
              >上一页</el-button
            >
            <el-button
              style="width: 150px"
              type="primary"
              @click="examinationNextStep('examinationForm')"
              >完成</el-button
            >
            <el-button style="width: 150px" type="test" @click="cancel"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <dialogHoursVue
      :selectedHourList="selectedHourList"
      :showDialogHoursSetting="showDialogHoursSetting"
      :currentSetHours="currentSetHours"
      :currentSetCourseIndex="currentSetCourseIndex"
      @colseDialog="colseDialog"
      @selectedCourseHours="selectedCourseHours"
    ></dialogHoursVue>
  </div>
</template>

<script>
import { findCityAllList } from "@/api/userLogin";
import {
  saveTrainingExam,
  platformTrainingExamDetail,
} from "@/api/examinationApi";
import {
  updatePlatformTraining,
  platformTrainingDetail,
  saveTrainingSeal,
  platformTrainingSealDetail,
} from "@/api/trainingManage";
import { msToDate } from "@/plugins/msToDate";
import { uploadFile } from "@/api/certificateTemplate";
import dialogPositionVue from "./dialogTraining/dialogPosition.vue";
// import dialogUnitVue from "./dialogTraining/dialogUnit.vue";
import dialogCourseVue from "./dialogTraining/dialogCourse.vue";
import dialogHoursVue from "./dialogTraining/dialogHours.vue";
import WangEditorVue from "@/components/WangEditor.vue";

export default {
  components: {
    dialogPositionVue,
    // dialogUnitVue,
    dialogCourseVue,
    dialogHoursVue,
    WangEditorVue,
  },
  data() {
    var checkAge = (rule, value, callback) => {
      var timeformat = /^(20[1-2][0-9])$/;
      if (!value) {
        return callback(new Error("年份不能为空"));
      } else if (!timeformat.test(value)) {
        callback(new Error("请输入类似于 2020-2022 格式的内容"));
      } else {
        callback();
      }
    };
    return {
      radio: "1",
      encoding: "",
      userAreaCodestatus: "",
      CodingHierarchy: "", //编码层级
      activeTab: "trainSetting",
      newActiveTab: "",
      oldActiveTab: "",
      trainingForm: {
        id: "",
        name: "",
        summary: "",
        trainingTime: [],
        area: [],
        trainingPosition: "custom",
        trainingUnit: "custom",
        courseIds: [],
        status: true,
        trainingCountState: false,
        trainingCount: "1",
        isCertificateApply: false,
        classHour: "",
        classType: "",
        ProfessionalCategory: "",
        trainingPeriod: "",
        trainingArea: "",
        UserregionArea: "",
      },
      trainingFormRules: {
        name: [{ required: true, message: "请输入培训名称", trigger: "blur" }],
        summary: [
          { required: true, message: "请输入培训简介", trigger: "blur" },
        ],
        trainingTime: [
          { required: true, message: "请选择培训时间", trigger: "change" },
        ],
        area: [{ required: true, message: "请选择地区", trigger: "click" }],
        courseIds: [
          { required: true, message: "请选择课程", trigger: "click" },
        ],
        trainingPeriod: [
          { required: true, validator: checkAge, trigger: "blur" },
        ],
        trainingArea: [
          {
            required: true,
            message: "设置培训地区编码不能为空",
            trigger: "blur",
          },
          { min: 6, max: 6, message: "长度必须整数", trigger: "blur" },
        ],
        UserregionArea: [
          {
            required: true,
            message: "默认培训地区编码不能为空",
            trigger: "blur",
          },
          { min: 6, max: 6, message: "长度必须整数", trigger: "blur" },
        ],
      },
      showDialogPositionSetting: false,
      showDialogUnitSetting: false,
      showDialogCourseSetting: false,
      showDialogHoursSetting: false,
      areaList: [],
      provList: [],
      cityList: [],
      districtList: [],
      streetList: [],
      selectedAreaList: [], // 选中的地区
      selectedUnitList: [], // 选中的单位
      selectedPositionList: [], // 选中的岗位
      selectedCourseList: [], // 选中的课程单位岗位id
      selectedHourList: [], // 当前课程中的必修课时id
      selectedCourseTableList: [], // 选中的课程对象
      defaultProps: {
        children: "children",
        label: "name",
      },
      // 所用章设置数据=====
      dynamicValidateForm: {
        // 考试机构
        domains: [
          {
            examineSealName: "",
            examineSealUrl: "",
          },
        ],
        // 培训机构
        trainingDomains: [
          {
            trainingSealName: "",
            trainingSealUrl: "",
          },
        ],
      },
      dynamicUploadIndex: 0,
      trainingUploadIndex: 0,
      // 考试设置数据=====
      examinationForm: {
        id: "",
        url: "",
        liveUrl: "",
      },
      examinationFormRules: {
        id: [{ required: true, message: "请输入考试GUID", trigger: "blur" }],
        url: [{ required: true, message: "请输入考试链接", trigger: "blur" }],
      },
      detailAreaIds: [],
      currentSetHours: {},
      currentSetCourseIndex: 0,
    };
  },
  created() {
    this.getFindCityAllList();
    this.getPlatformTrainingDetail(this.$route.query.id);
  },
  watch: {
    activeTab(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (newVal == "chapterUsed") {
        this.platformTrainingSealDetail(this.trainingForm.id);
      }
      if (newVal == "examination") {
        this.platformTrainingExamDetail(this.trainingForm.id);
      }
    },
    showDialogUnitSetting(newVal) {
      if (!newVal) {
        this.selectedUnitList = this.selectedUnitList.filter(
          (obj, index) =>
            this.selectedUnitList.findIndex((item) => item.id === obj.id) ===
            index
        );
      }
    },
    showDialogHoursSetting(val) {
      if (!val) {
        this.selectedHourList = [];
      }
    },
  },
  computed: {},
  methods: {
    encodingChange(e) {
      console.log(e, "666");
      if (e == 1) {
        this.userAreaCodestatus = false;
      } else {
        this.userAreaCodestatus = true;
      }
    },
    // 获取富文本中的内容
    getEditorContent(val) {
      console.log("val", val);
      this.trainingForm.summary = val;
    },
    // tab栏切换时触发
    beforeTabLeave(newActiveName, oldActiveName) {
      let flag = true;
      this.$refs["trainingForm"].validate((valid) => {
        if (valid) {
          this.newActiveTab = newActiveName;
          this.oldActiveTab = oldActiveName;
          flag = true;
        } else {
          flag = false;
        }
      });
      return flag;
    },
    toInteger() {
      let reg = /^[0-9]+$/;
      if (!reg.test(this.trainingForm.trainingCount)) {
        this.$message.warning("只能输入整数");
        // 用以在dom渲染挂载后重新触发dom渲染挂载
        this.$nextTick(() => {
          this.trainingForm.trainingCount = parseInt(
            this.trainingForm.trainingCount
          );
        });
      }
    },
    // 获取地区
    async getFindCityAllList() {
      let res = await findCityAllList();
      if (res.data.result == "success") {
        this.areaList = res.data.msg;
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.detailAreaIds);
          for (let i = 0; i < this.detailAreaIds.length; i++) {
            let node = this.$refs.tree.getNode(this.detailAreaIds[i]);
            if (node.data.level == 3) {
              let item = {
                street: node.data.id,
                district: node.parent.data.id,
                city: node.parent.parent.data.id,
                provice: node.parent.parent.parent.data.id,
              };
              this.trainingForm.area.push(item);
            }
          }
        });
      }
    },
    removeDuplicates(arr) {
      let result = [];
      result = arr.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.lesson.id === item.lesson.id)
      );
      return result;
    },
    // 获取编辑内容数据
    async getPlatformTrainingDetail(id) {
      let res = await platformTrainingDetail({ id: id });
      console.log(res, "platformTrainingDetail");
      if (res.data.list) {
        this.trainingForm.id = res.data.list.id;
        // 培训名称
        this.trainingForm.name = res.data.list.name;
        // 培训简介
        this.trainingForm.summary = res.data.list.content;
        // 培训时间
        this.trainingForm.trainingTime = [
          new Date(res.data.list.trainingBeginTime),
          new Date(res.data.list.trainingEndTime),
        ];
        // 地点设置
        this.detailAreaIds = res.data.list.streetId.split(",");
        // 证书上的课程学时
        this.trainingForm.classHour = res.data.list.lessonHourNumber;
        // 证书上的课程类型专业类别
        this.trainingForm.classType = res.data.list.lessonType;
        // 专业类别
        this.trainingForm.ProfessionalCategory =
          res.data.list.professionalCategory;
        // 培训年份设置
        this.encoding = res.data.list.userAreaCodeStatus ? "2" : "1";
        this.trainingForm.trainingPeriod = res.data.list.otherYear;
        // 设置培训地区编码
        this.trainingForm.trainingArea = res.data.list.areaCode;
        // 默认培训地区编码
        this.trainingForm.UserregionArea = res.data.list.areaCode;
        this.CodingHierarchy = res.data.list.userAreaCodeLevel;
        // 是否公开
        this.trainingForm.status = res.data.list.status == 1 ? true : false;
        if (res.data.list.trainingCount <= 0) {
          this.trainingForm.trainingCount = res.data.list.trainingCount;
          this.trainingForm.trainingCountState = false;
        } else {
          this.trainingForm.trainingCount = res.data.list.trainingCount;
          this.trainingForm.trainingCountState = true;
        }
        let resultList = res.data.list.resultList.map((item) => {
          let hourId = [];
          if (item.hourList) {
            item.hourList.forEach((hour) => {
              hourId.push(hour.id);
            });
          }
          return {
            company: item.company,
            hourList: hourId,
            lesson: item.lesson,
            position: item.position,
          };
        });
        // 岗位
        this.selectedPositionList = res.data.list.positionList;
        // 单位
        this.selectedUnitList = JSON.parse(
          JSON.stringify(res.data.list.companyList)
        );
        // 课程设置
        this.trainingForm.courseIds.push(res.data.list.lessonIds);
        this.selectedCourseTableList = this.removeDuplicates(resultList);
        this.selectedCourseList = this.selectedCourseTableList.map((item) => ({
          lessonId: item.lesson ? item.lesson.id : "",
          companyId: item.company ? item.company.id : "",
          positionId: item.position ? item.position.id : "",
          hourId: item.hourList.join(","),
        }));
        this.trainingForm.courseIds = this.selectedCourseTableList.map(
          (item) => item.lesson.id
        );
      } else {
        this.$message.error("获取失败");
      }
    },
    // 获取所用章数据
    async platformTrainingSealDetail(id) {
      let res = await platformTrainingSealDetail({ id: id });
      if (res.data.result == "success") {
        if (res.data.EducationTrainingSealExaim.length != 0) {
          this.dynamicValidateForm.domains =
            res.data.EducationTrainingSealExaim;
        }
        if (res.data.educationTrainingSealTraining.length != 0) {
          this.dynamicValidateForm.trainingDomains =
            res.data.educationTrainingSealTraining;
        }
      } else {
        this.$message.error("获取失败");
      }
    },
    // 获取考试设置数据
    async platformTrainingExamDetail(id) {
      let res = await platformTrainingExamDetail({ traingId: id });
      if (res.data.result == "success") {
        if (res.data.educationTrainingExam) {
          this.examinationForm.id = res.data.educationTrainingExam.pid;
        }
        if (res.data.tPlatformTraining) {
          this.examinationForm.liveUrl = res.data.tPlatformTraining.liveUrl;
        }
      } else {
        this.$message.error("获取失败");
      }
    },
    // 培训设置下一步
    trainingNextStep(formName) {
      let positionIds = [];
      // let companyIds = [];
      let lessonList = [];
      if (this.selectedPositionList.length != 0) {
        this.selectedPositionList.forEach((item) => positionIds.push(item.id));
      }
      // if (this.selectedUnitList.length != 0) {
      //   this.selectedUnitList.forEach((item) => companyIds.push(item.id));
      // }
      for (let i = 0; i < this.selectedCourseList.length; i++) {
        // for (let j = 0; j < this.selectedUnitList.length; j++) {
        for (let k = 0; k < this.selectedPositionList.length; k++) {
          // Code to be executed inside the nested for loop
          let item = {
            lessonId: this.selectedCourseList[i].lessonId,
            // companyId: this.selectedUnitList[j].id,
            positionId: this.selectedPositionList[k].id,
            hourId: this.selectedCourseList[i].hourId,
          };
          lessonList.push(item);
        }
        // }
      }
      console.log(lessonList, "lessonList");
      // if (this.trainingForm.courseIds.length == 0) {
      //   this.$message.error("请选择课程");
      //   return;
      // }
      if (!this.trainingForm.trainingCountState) {
        this.trainingForm.trainingCount = "";
      }
      console.log(
        "this.userAreaCodestatus cur state => ",
        this.userAreaCodestatus
      );
      let param = {
        id: this.$route.query.id,
        name: this.trainingForm.name,
        content: this.trainingForm.summary,
        areaList: this.trainingForm.area,
        lessonList: lessonList,
        positionIds: positionIds.join(","),
        // companyIds: companyIds.join(","),
        lessonIds: this.trainingForm.courseIds.join(","),
        userId: this.$store.state.userInfo.id,
        trainingBeginTime: msToDate(this.trainingForm.trainingTime[0]),
        trainingEndTime: msToDate(this.trainingForm.trainingTime[1]),
        status: this.trainingForm.status ? "1" : "0",
        trainingCount: this.trainingForm.trainingCount,
        isApplicationCert: this.trainingForm.isCertificateApply ? 1 : 0,
        lessonHourNumber: this.trainingForm.classHour,
        lessonType: this.trainingForm.classType,
        professionalCategory: this.trainingForm.ProfessionalCategory,
        otherYear: this.trainingForm.trainingPeriod,
        userAreaCodeStatus: this.userAreaCodestatus,
        areaCode: this.trainingForm.trainingArea
          ? this.trainingForm.trainingArea
          : this.trainingForm.UserregionArea,
        userAreaCodeLevel: this.userAreaCodestatus
          ? this.CodingHierarchy
          : null,
      };
      console.log(param, "param");
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // 表单验证通过，提交
          let res = await updatePlatformTraining(param);
          if (res.data.result == "success") {
            console.log(res, "res");
            // this.$message({
            //   type: "success",
            //   message: res.data.msg,
            // });
            this.activeTab = "chapterUsed";
          }
        } else {
          // 表单验证不通过
          console.log("validate failed");
          return false;
        }
      });
    },
    // 所用章设置下一步
    dynamicNextStep(formName) {
      let param = {
        userId: this.$store.state.userInfo.id,
        traingId: this.$route.query.id,
        exaimList: this.dynamicValidateForm.domains,
        trainingList: this.dynamicValidateForm.trainingDomains,
      };
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // 表单验证通过，提交
          let res = await saveTrainingSeal(param);
          if (res.data.result == "success") {
            // console.log(res, "res");
            // this.$message({
            //   type: "success",
            //   message: res.data.msg,
            // });
            this.activeTab = "examination";
          }
        } else {
          // 表单验证不通过
          console.log("validate failed");
          this.activeTab = "examination";
          return false;
        }
      });
    },
    // 考试设置下一步
    examinationNextStep(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // 表单验证通过，提交
          let res = await saveTrainingExam({
            pid: this.examinationForm.id,
            traingId: this.$route.query.id,
            liveUrl: this.examinationForm.liveUrl,
          });
          if (res.data.result == "success") {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.$router.go(-1);
          } else {
            // this.$message({
            //   type: "error",
            //   message: res.data.msg,
            // });
            this.$router.go(-1);
          }
        } else {
          // 表单验证不通过
          console.log("validate failed");
          this.$router.go(-1);
          return false;
        }
      });
    },
    // 上一页
    previousPage() {
      this.activeTab = this.oldActiveTab;
    },
    // 取消
    cancel() {
      // Cancel logic
      this.$router.go(-1);
    },
    // 当前选中的地区节点发生变化
    handleCheckChangeArea(data, checked) {
      console.log(data, checked, "地区");
      if (checked) {
        if (data.level == 3) {
          this.streetList.push(data.id);
        }
      }
      if (!checked) {
        if (data.level == 3) {
          this.streetList = this.streetList.filter(
            (item) => item.id !== data.id
          );
        }
      }
      // console.log(this.streetList, "this.streetList");
    },
    currentChangeArea(checkedNodes, checkedKeys) {
      console.log(checkedNodes, checkedKeys, "checkedNodes, checkedKeys");
      // 获取选中节点的node对象
      this.nodes = checkedKeys.checkedNodes;
      let areaArr = [];
      for (let i = 0; i < this.nodes.length; i++) {
        let node = this.$refs.tree.getNode(this.nodes[i].id);
        if (node.level == 4) {
          let item = {
            street: node.data.id,
            district: node.parent.data.id,
            city: node.parent.parent.data.id,
            provice: node.parent.parent.parent.data.id,
          };
          areaArr.push(item);
        }
      }
      this.trainingForm.area = areaArr;
      console.log(this.trainingForm.area);
    },
    // 选择培训岗位弹出
    dialogPositionSetting() {
      if (this.trainingForm.area.length != 0) {
        this.showDialogPositionSetting = true;
      }
    },
    // 对话框选中的岗位
    selectedPosition(data) {
      this.selectedPositionList = data;
      this.selectedCourseTableList = [];
      this.selectedCourseList = [];
      this.trainingForm.courseIds = [];
    },
    // 删除选中的岗位
    deleteSelectedPosition(row) {
      console.log(row, "row", row.$index);
      this.selectedPositionList.splice(row.$index, 1);
      this.selectedCourseTableList = [];
      this.selectedCourseList = [];
      this.trainingForm.courseIds = [];
    },
    // 选择培训单位弹出
    dialogUnitSetting() {
      if (this.trainingForm.area.length != 0) {
        this.showDialogUnitSetting = true;
      }
    },
    // 对话框选中的单位
    selectedUnit(data) {
      console.log(data, "data");
      this.selectedUnitList = data;
      this.selectedCourseTableList = [];
      this.selectedCourseList = [];
      this.trainingForm.courseIds = [];
    },
    // 删除选中的单位
    deleteSelectedUnit(row) {
      console.log(row, "row", row.$index);
      this.selectedUnitList.splice(row.$index, 1);
      this.selectedCourseTableList = [];
      this.selectedCourseList = [];
      this.trainingForm.courseIds = [];
    },
    // 选择课程设置弹出
    dialogCourseSetting() {
      if (
        // this.selectedUnitList.length != 0 &&
        this.selectedPositionList.length != 0
      ) {
        this.showDialogCourseSetting = true;
      }
    },
    // 设置必修课时
    dialogHoursSetting(row, index) {
      this.showDialogHoursSetting = true;
      this.currentSetHours = row;
      this.currentSetCourseIndex = index;
      if (this.currentSetHours.hourList) {
        this.selectedHourList = this.currentSetHours.hourList;
      }
      console.log(
        this.currentSetHours,
        "dialogHoursSetting",
        this.currentSetCourseIndex
      );
    },
    selectedCourseHours(val) {
      this.selectedCourseList[val.index].hourId = val.checkList.join(",");
      this.selectedCourseTableList[val.index].hourList = val.checkList;
      console.log(
        val,
        "selectedCourseHours",
        this.selectedCourseList,
        this.selectedCourseTableList
      );
    },
    // 对话框选中的课程
    selectedUnitAndPositionAndCourse(param) {
      this.trainingForm.courseIds = param.lessonIds;
      this.selectedCourseTableList = param.tableList;
      this.selectedCourseList = param.ids;
      console.log(
        param,
        "param",
        this.selectedCourseList,
        this.selectedCourseTableList
      );
    },
    // 删除选中的课程
    deleteSelectedCourse(row) {
      this.selectedCourseTableList.splice(row.$index, 1);
      this.selectedCourseList.splice(row.index, 1);
      console.log(
        row,
        "row",
        row.$index,
        this.selectedCourseList,
        this.selectedCourseTableList
      );
    },
    colseDialog(val) {
      console.log(val, "fdsa");
      this.showDialogPositionSetting = val;
      this.showDialogUnitSetting = val;
      this.showDialogCourseSetting = val;
      this.showDialogHoursSetting = val;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    // 所用章操作部分===================
    // 上传考试机构所用章
    async templateFileChange(file, fileList) {
      console.log(file, fileList, "file,fileList");
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt2M = file.raw.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传所用章只能是 JPG和PNG 格式!");
        return;
      }
      if (!isLt2M) {
        this.$message.error("上传所用章大小不能超过 2MB!");
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      let res = await uploadFile(formData);
      if (res.data.result == "success") {
        this.dynamicValidateForm.domains[
          this.dynamicUploadIndex
        ].examineSealUrl = res.data.msg;
      }
      console.log(res, "templateFileChange");
    },
    // 上传培训机构所用章
    async trainingFileChange(file, fileList) {
      console.log(file, fileList, "file,fileList");
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt2M = file.raw.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传所用章只能是 JPG和PNG 格式!");
        return;
      }
      if (!isLt2M) {
        this.$message.error("上传所用章大小不能超过 2MB!");
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      let res = await uploadFile(formData);
      if (res.data.result == "success") {
        this.dynamicValidateForm.trainingDomains[
          this.trainingUploadIndex
        ].trainingSealUrl = res.data.msg;
      }
      console.log(res, "trainingFileChange");
    },
    // 当前上传考试机构所用章索引
    templateFileClick(index) {
      console.log(index, "templateFileClick");
      this.dynamicUploadIndex = index;
    },
    // 添加考试设置
    addDomain() {
      this.dynamicValidateForm.domains.push({
        examineSealName: "",
        examineSealUrl: "",
        key: Date.now(),
      });
    },
    // 当前上传培训机构所用章索引
    trainingFileClick(index) {
      console.log(index, "templateFileClick");
      this.trainingUploadIndex = index;
    },
    // 添加培训所用章设置
    trainingAddDomain() {
      this.dynamicValidateForm.trainingDomains.push({
        trainingSealName: "",
        trainingSealUrl: "",
        key: Date.now(),
      });
    },

    // 删除考试所用章设置
    removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },

    // 删除培训所用章设置
    trainingRemoveDomain(item) {
      var index = this.dynamicValidateForm.trainingDomains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.trainingDomains.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
.form-container {
  margin: 50px 100px;
  max-width: 1000px;
}

.button-container {
  margin-top: 20px;
  text-align: center;
}
.area-setting,
.select-course,
.position-setting,
.unit-setting {
  border: 1px dashed #797979;
  width: 300px;
  height: 30px;
  border-radius: 10px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  margin-top: 10px;
}
.el-scrollbar {
  height: 500px;
  width: 300px;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 20px 0 0 0;
}
.mb-20 {
  margin-bottom: 20px;
}
.icon-style {
  font-weight: 700;
  font-size: 24px;
  margin: 0 5px;
  cursor: pointer;
}
.icon-style:hover {
  color: #ccc;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  border: 1px dashed #d9d9d9;
  width: 178px;
  height: 178px;
  display: block;
}
</style>
